import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

import Input from "../../controls/Input";
import ReadonlyIdentifierField from "../../controls/ReadonlyIdentifierField";
import TraceableBarcode from "../../controls/TraceableBarcode";
import TraceableLotNumber from "../../controls/TraceableLotNumber";
import { classNames, formatDateWithTime } from "../../../shared/utility";

export default function ManufacturedItemInfo(props) {
  const { setOpen, item } = props;

  return (
    <div className="hide-for-print flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
      <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll py-6">
        <div className="px-4 sm:px-6">
          <div className="flex items-start justify-between">
            <Dialog.Title className="text-base font-semibold leading-6 text-gray-900">
              {item.product_name}
            </Dialog.Title>
            <div className="ml-3 flex h-7 items-center">
              <button
                type="button"
                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                onClick={() => setOpen({ childComponent: null, open: false })}
              >
                <span className="sr-only">Close panel</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
        <div className="relative mt-6 flex-1 px-4 sm:px-6 space-y-4">
          <div className="grid grid-cols-4 gap-2">
            <Input
              label="PLU"
              value={item.plu}
              labelOn={true}
              disabled={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <ReadonlyIdentifierField label="Lot Number">
              <TraceableLotNumber lotNumber={item.lot_number} traceType="manufactured" />
            </ReadonlyIdentifierField>
            <Input
              label="Produced Weight"
              value={`${item.produced_net_kg} kg`}
              labelOn={true}
              disabled={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Produced Pieces"
              value={`${item.produced_piece_count} pieces`}
              labelOn={true}
              disabled={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Date created"
              value={formatDateWithTime(item.created_date)}
              labelOn={true}
              disabled={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Created by"
              value={item.created_by_name}
              labelOn={true}
              disabled={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <ReadonlyIdentifierField label="Barcode" className="col-span-2">
              <TraceableBarcode barcode={item.barcode} />
            </ReadonlyIdentifierField>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <Input
              label="Warehouse"
              value={item.warehouse_name}
              labelOn={true}
              disabled={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Location"
              value={item.warehouse_location_name}
              labelOn={true}
              disabled={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>
          {item.receiving ? (
            <div className="space-y-2">
              <p className="text-base font-semibold leading-6 text-gray-900">
                Receiving info
              </p>
              <div className="grid grid-cols-4 gap-2">
                <Input
                  label="PO Number"
                  value={item.receiving.invoice_number}
                  labelOn={true}
                  disabled={true}
                  type="text"
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                />
                <Input
                  label="Supplier Name"
                  value={item.receiving.supplier_name}
                  labelOn={true}
                  disabled={true}
                  type="text"
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                />
                <ReadonlyIdentifierField label="Lot Number">
                  <TraceableLotNumber lotNumber={item.receiving.lot_number} traceType="supplier" />
                </ReadonlyIdentifierField>
                <Input
                  label="Date created"
                  value={formatDateWithTime(item.receiving.created_date)}
                  labelOn={true}
                  disabled={true}
                  type="text"
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                />
              </div>
              <div className="grid grid-cols-3 gap-x-4 gap-y-2">
                <Input
                  label="Received by"
                  value={item.receiving.received_by_name}
                  labelOn={true}
                  disabled={true}
                  type="text"
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                />
                <Input
                  label="PLU"
                  value={item.receiving.plu}
                  labelOn={true}
                  disabled={true}
                  type="text"
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                />
                <Input
                  label="Truck Number"
                  value={item.receiving.truck_number}
                  labelOn={true}
                  disabled={true}
                  type="text"
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                />
                <ReadonlyIdentifierField label="Barcode" className="col-span-3">
                  <TraceableBarcode barcode={item.receiving.barcode} />
                </ReadonlyIdentifierField>
              </div>
              <div className="grid grid-cols-4 gap-2">
                <Input
                  label="Weight"
                  value={`${item.receiving.net_weight} ${item.receiving.stock_unit_of_measurement_name}`}
                  labelOn={true}
                  disabled={true}
                  type="text"
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                />
                <Input
                  label="Piece Count"
                  value={item.receiving.piece_count}
                  labelOn={true}
                  disabled={true}
                  type="text"
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                  parentClass={classNames(
                    item.stock_unit_of_measurement === 3 ? null : "hidden"
                  )}
                />
                <Input
                  label="Unit Cost"
                  value={`$${item.receiving.unit_cost}`}
                  labelOn={true}
                  disabled={true}
                  type="text"
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                />
                <Input
                  label="Total Cost"
                  value={`$${item.receiving.total_cost}`}
                  labelOn={true}
                  disabled={true}
                  type="text"
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                />
              </div>
              <div className="grid grid-cols-2 gap-2">
                <Input
                  label="Warehouse"
                  value={item.receiving.warehouse_name}
                  labelOn={true}
                  disabled={true}
                  type="text"
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                />
                <Input
                  label="Location"
                  value={item.receiving.warehouse_location_name}
                  labelOn={true}
                  disabled={true}
                  type="text"
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                />
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
